import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { CNavbarBrand } from '@coreui/react';
import DefaultAppHeaderDropdown from './DefaultAppHeaderDropdown';
import CreateCollection from '../../elements/Collections/CreateCollection';
import { connect } from 'react-redux';

interface SidebarTogglerProps {
  className?: string;
  mobile?: boolean;
  children?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SidebarToggler: React.FC<SidebarTogglerProps> = ({ className, mobile, children }) => (
  <button
    type="button"
    className={`header-toggler ${className || ''}`}
    onClick={() => {
      if (mobile) {
        document.body.classList.toggle('sidebar-show');
      } else {
        document.body.classList.toggle('sidebar-lg-show');
      }
    }}
  >
    {children || <span className="header-toggler-icon" />}
  </button>
);

interface WhiteLabelInfo {
  logoUrl?: string | null;
  iconUrl?: string | null;
  [key: string]: any;
}

interface User {
  type?: string;
  whiteLabel: WhiteLabelInfo;
  [key: string]: any;
}

interface StateProps {
  user: User;
}

interface OwnProps {
  onlyLogout?: boolean;
  toggleSidebar?: () => void;
}

const DefaultHeader: React.FC<StateProps & OwnProps> = ({ user, onlyLogout, toggleSidebar }) => {
  const handleToggle = () => {
    if (toggleSidebar) {
      toggleSidebar();
    }
  };

  return (
    <>
      {!onlyLogout && (
        <button
          type="button"
          className="header-toggler d-lg-none"
          onClick={handleToggle}
          aria-label="Toggle sidebar"
        >
          <span className="header-toggler-icon" />
        </button>
      )}

      <CNavbarBrand href="/#" className="p-2">
        {user.type !== 'SB' && user.whiteLabel.logoUrl ? (
          <img
            src={user.whiteLabel.logoUrl}
            style={{ width: user.type === 'VST' ? '50px' : '100%' }}
            alt="Logo"
            className="sidebar-brand-full"
          />
        ) : null}
        {user.whiteLabel.iconUrl && (
          <img
            src={user.whiteLabel.iconUrl}
            width={30}
            height={30}
            alt="Icon"
            className="sidebar-brand-narrow"
          />
        )}
      </CNavbarBrand>

      {!onlyLogout && (
        <button
          type="button"
          className="header-toggler d-md-down-none"
          onClick={handleToggle}
          aria-label="Toggle sidebar"
        >
          <span className="header-toggler-icon" />
        </button>
      )}

      {!onlyLogout && (
        <Nav navbar>
          <NavItem className="pr-3">
            <CreateCollection />
          </NavItem>
        </Nav>
      )}
      <DefaultAppHeaderDropdown onlyLogout={onlyLogout} />
    </>
  );
};

// Using any for RootState to avoid broad changes; we only extract auth as user
const mapStateToProps = ({ auth }: any): StateProps => ({ user: auth });

export default connect<StateProps, unknown, OwnProps, any>(mapStateToProps, null)(DefaultHeader);
